/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BindingOut } from './bindingOut';
import type { ConsentSummary } from './consentSummary';
import type { EntityRef } from './entityRef';
import type { ParticipantLite } from './participantLite';
import type { RowOutProperties } from './rowOutProperties';

export interface RowOut {
  id: string;
  title: string;
  meeting_type: string;
  state: string;
  state_reason: string | null;
  state_stage: string | null;
  capture_outcome: string | null;
  capture_mode: string;
  data_class: string;
  scheduled_start: string;
  scheduled_end: string;
  actual_start: string | null;
  actual_end: string | null;
  partial: boolean;
  partial_reason: string | null;
  multi_candidate: boolean;
  match_not_needed: boolean;
  archived_at: string | null;
  project_id: string | null;
  binding: BindingOut | null;
  job: EntityRef | null;
  job_candidate: EntityRef | null;
  employer: EntityRef | null;
  participants: ParticipantLite[];
  consent_summary: ConsentSummary;
  diarization_quality: string | null;
  scorecard_definition: EntityRef | null;
  scorecard_type_source: string | null;
  properties: RowOutProperties;
  attention: string[];
  meeting_url?: string | null;
}
